import React from 'react'

import classNamesBind from 'classnames/bind'
import css from './styles.module.scss'
const classNames = classNamesBind.bind(css)

type Option = {
  value: string
  label: string
  tooltip?: string
}

interface Props {
  options: [Option, Option]
  value: string | null
  staticMode?: boolean
  discType?: string
}

interface State {}

class ToggleOption extends React.Component<Props, State> {
  render() {
    const { options, value, staticMode, discType } = this.props
    const [left, right] = options

    return (
      <div
        className={classNames('container', {
          staticMode,
          emptyState: value === null,
        })}
      >
        <div
          className={classNames('option', discType, {
            active: value === left.value,
          })}
        >
          <div className={css.text}>{left.label}</div>
          {this.renderToolTip(left.tooltip)}
        </div>
        <div
          className={classNames('option', discType, {
            active: value === right.value,
          })}
        >
          <div className={css.text}>{right.label}</div>
          {this.renderToolTip(right.tooltip)}
        </div>
      </div>
    )
  }

  renderToolTip(tooltip?: string) {
    if (!tooltip) return null

    return <div className={css.tooltip}>{tooltip}</div>
  }
}

export default ToggleOption
